<template>
  <v-overlay color="primary" opacity="1" style="z-index: 1000">
    <Loading text="Logging out ..." progress_color="white" />
  </v-overlay>
</template>

<script>
import { showSnackbar, logout } from '@/actions'
import Loading from '@/components/Loading'

export default {
  components: { Loading },

  mounted() {
    if (logout) {
      showSnackbar('Logged out', null, 'success')
      this.$router.replace({ name: 'login' })
    } else {
      showSnackbar('Logout failed', null, 'error')
      this.$router.back()
    }
  },
}
</script>
